<template>
  <div class="user-wrapper">
    <!-- <a href="https://www.kancloud.cn/ncnk/jiqirenpeizhijiaocheng/748780" target="_blank" v-if="!isMobile()">
      <span class="action">
        <a-icon type="question-circle-o"></a-icon>
      </span>
    </a>-->
    <template v-if="!isMobile()">
      <a href="http://zjzd.nianchu.net" target="_blank" v-if="use_forum">紫禁之巅</a>
      <a v-if="is_show" @click="handleMarketPlugin">
        <a-badge
          count="新"
          :numberStyle="{
            'font-size': '10px',
            '-webkit-transform-origin-x': 0,
            '-webkit-transform': 'scale(0.90)',
          }"
          :offset="[6, -10]"
          v-if="countL != 10"
        >
          <span class="action">{{marketPluginTitle}}</span>
        </a-badge>
        <span v-if="countL == 10" class="action">{{marketPluginTitle}}</span>
      </a>
      <a :href="download_app" target="_blank" v-if="!download_show">
        <span class="action">下载软件包</span>
      </a>
      <!-- <a @click="handleTui" v-if="spread">
      <span class="action">推广中心</span>
    </a> -->
      <a @click="handleProperty" v-if="spread">
        <span class="action">资产管理</span>
      </a>
    </template>
    <template v-else>
      <a-dropdown>
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">更多<a-icon type="down" /> </a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a href="http://zjzd.nianchu.net" target="_blank" v-if="use_forum">紫禁之巅</a>
          </a-menu-item>
          <a-menu-item>
            <a v-if="is_show" @click="handleMarketPlugin">
              <a-badge
                count="新"
                :numberStyle="{
                  'font-size': '10px',
                  '-webkit-transform-origin-x': 0,
                  '-webkit-transform': 'scale(0.90)',
                }"
                :offset="[6, -10]"
                v-if="countL != 10"
              >
                <span class="action">{{marketPluginTitle}}</span>
              </a-badge>
              <span v-if="countL == 10" class="action">{{marketPluginTitle}}</span>
            </a>
          </a-menu-item>
          <a-menu-item>
            <a :href="download_app" target="_blank" v-if="!download_show">
              <span class="action">下载软件包</span>
            </a>
          </a-menu-item>
          <a-menu-item>
            <a @click="handleProperty" v-if="spread">
              <span class="action">资产管理</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </template>
    <!-- <notice-icon class="action"/> -->
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="avatar()" />
        <span>{{ nickname() }} </span>
        <a-icon type="caret-down" />
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="0" @click="handleTui" v-if="spread">
          <a-icon type="user-add" />
          <span>推广中心</span>
        </a-menu-item>
        <a-menu-item key="1">
          <router-link :to="{ name: 'AccountSettingsSecurity' }">
            <a-icon type="setting" />
            <span>账户设置</span>
          </router-link>
        </a-menu-item>
        <!-- <a-menu-item key="2" disabled>
          <a-icon type="setting"/>
          <span>测试</span>
        </a-menu-item> -->
        <a-menu-divider />
        <a-menu-item key="3">
          <a href="javascript:;" @click="handleLogout">
            <a-icon type="logout" />
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'UserMenu',
  components: {
    NoticeIcon,
  },
  mixins: [mixinDevice],
  computed: {
    marketPluginTitle(){
      let title = this.$store.state.brand.extend_data['buyCamille']?.title
      return title?title:'插件市场'
    },
    im_app() {
      return this.$store.state.brand.im_app
    },
    download_app() {
      return this.$store.state.brand.download_app
    },
    spread() {
      return this.$store.state.brand.spread
    },
    countL() {
      return localStorage.getItem('countL')
    },
    download_show() {
      const extend = this.$store.state.brand.extend
      return extend.includes('HideWorkplace')
    },
    use_forum() {
      const extend = this.$store.state.brand.extend
      return extend.includes('UseForum')
    },
    is_show() {
      const extend = this.$store.state.brand.extend
      return !extend.includes('HidePluginEntrance')
    },
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout() {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.reload()
            })
            .catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message,
              })
            })
        },
        onCancel() {},
      })
    },
    handleTui() {
      // this.$message.warning('暂时维护，即将开放')
      // return false
      this.$router.push({ name: 'ConductCenter' })
    },
    handleProperty() {
      // this.$message.warning('暂时维护，即将开放')
      // return false
      this.$router.push({ name: 'PropertyCenter' })
    },
    handleMarketPlugin() {
      const extend = this.$store.state.brand.extend
      if (extend.includes('BuyCamille')) {
        window.open(this.$store.state.brand.extend_data['buyCamille']['url'])
      } else {
        this.$router.push({ name: 'MarketPlugin' })
      }

    },
  },
}
</script>
